import type { FaireProductEntity } from "../../entity_types/product";

export const p_dn4byy3vf9: FaireProductEntity = {
  token: "p_dn4byy3vf9",
  type: "product",
  name: "Baddie Grip Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/039d3853225254a3b2a8af3d83afe918567133429d5dba2ab67c7c4523f12939.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/19ff5ecb9d0c9ddd99eca962d1d4d1b709be9747a3e903308f6ff1c5e35007e9.jpeg",
    "https://cdn.faire.com/fastly/53de05720d5dd99b95b3f0fb727ff05cfcb7407a8263e911985fa5d646f3a4e8.jpeg",
    "https://cdn.faire.com/fastly/3a28b577374e3fc9fd4721c050ab4332c3a2654d0225f15e19721eee2eb13ca7.jpeg",
    "https://cdn.faire.com/fastly/917210bed659c38fc33cafb78fa3c7141084ed9062fe2f63720037e0fce3fbac.jpeg",
    "https://cdn.faire.com/fastly/fb199be34e7a992ac45b464c4240c263748be1920a16cd4ea40e4d213b6f31fe.jpeg",
    "https://cdn.faire.com/fastly/ba95f75d33c6220b083ce61084569f3da553aa4d2c10afc6faec1de31ba09788.jpeg",
    "https://cdn.faire.com/fastly/19f0855fd9d6c10e6dd73257d817587027d2a6fb64ac2568dbf82830e826467d.jpeg"
  ],
  priceDollars: 9.6,
  description: "A grip sock for confidence that doesn’t wait for permission (and also maybe does a little light crime sometimes 🤭)\n\nFinally! Grip socks that do a better job and look good doing it. 🤩\n\n• Woven-in premium grip yarn that holds up use after use. No glued-on dots.\n• Knit into the heel and toe, not just the sole, for better stability.\n• Built for Pilates, barre, yoga, and every stretch in between.\n• Bold, funny, and unreasonably well made in the USA!\n\n#pilatessocks #gripsocks #grippysocks #barresocks #yogasocks #grippy #lagreesocks #pilates #barre #lagree #yoga #grip\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:14.907Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
